import React, { useState, useEffect } from "react";
// import "./resetPassword.css";
import Header from "../../components/header1/Header1";
import Footer from "../../components/footer/Footer";
import mobileBannerImage from '../../elements/mobile_bg.png';
import bannerImage from '../../elements/hero-banner-login-page.png';
import { Link, useNavigate } from "react-router-dom";
import { updateUserPassword } from "../../services/studentportalapis"; // Import your API function
import Logo from "../../elements/Agivant-AMP-D-SE-Logo-Final 1.png";

const ResetPassword = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate(); // useNavigate hook to programmatically navigate
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Retrieve email from localStorage on component mount and check if email is empty
    useEffect(() => {
        const storedEmail = localStorage.getItem("email"); // Assuming the email is stored with the key "email"

        if (!storedEmail || storedEmail.trim() === "") {
            navigate("/forgot-password"); // Redirect to forgot-password page if email is blank
        } else {
            setEmail(storedEmail);
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setErrorMessage("");
        setSuccessMessage("");

        // Validation logic
        if (currentPassword === newPassword) {
            setErrorMessage("Old Password cannot be your new password!");
            return;
        }
        if (!currentPassword) {
            setErrorMessage("Current password is required.");
            return;
        }
        if (newPassword.length < 8) {
            setErrorMessage("New password must be at least 8 characters long.");
            return;
        }
        if (newPassword !== confirmPassword) {
            setErrorMessage("Passwords do not match.");
            return;
        }

        try {
            // Call the backend API to update the password
            const response = await updateUserPassword(email, currentPassword, newPassword);

            if (response.ok) {
                setSuccessMessage("Password updated successfully!");
                window.dispatchEvent(new Event("force-logout"));
                setTimeout(() => {
                    navigate("/login"); // Navigate to the login page after a brief delay
                }, 2000);
            } else {
                // Handle different errors from backend response
                if (response.status === 401) {
                    setErrorMessage("Current password is incorrect.");
                } else if (response.status === 404) {
                    setErrorMessage("User not found.");
                } else {
                    setErrorMessage("Error updating password.");
                }
            }
        } catch (error) {
            // Handle unexpected errors
            setErrorMessage("Current password is incorrect.");
        }
    };

     useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
    
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    return (
        <div className="page-container" >
            <Header />
             <div
                    className="grid grid-cols-1 md:grid-cols-2 min-h-screen bg-cover bg-center"
                    style={{
                      backgroundImage: `url(${isMobile ? mobileBannerImage : bannerImage})`,
                    }}>
                {/* Left Side */}

                <div className="flex items-center justify-center px-4 ">
                    <div className="p-6 sm:p-8 w-full max-w-md mx-auto">
                        <div className='flex justify-center'>
                                      {isMobile && <img className='w-2/3 h-2/3' src={Logo} alt="Logo" />}
                                    </div>
                        <h2 className="text-2xl sm:text-3xl text-white font-bold text-center mb-6">Reset Password</h2>

                        {/* Display email */}
                        <p className="text-white md:!text-black">You are resetting the password for :

                        {/* Link to change email */}
                        <Link to="/forgot-password" className="text-indigo-200 hover:underline">
                            {' '}{email}
                            </Link>
                        </p>
                        

                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label htmlFor="currentPassword" className="block text-white font-semibold mb-2">Current Password <span class="text-red-500">*</span> </label>
                                <input
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    type="password"
                                    id="currentPassword"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="newPassword" className="block text-white font-semibold mb-2">Enter New Password <span class="text-red-500">*</span> </label>
                                <input
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    type="password"
                                    id="newPassword"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="confirmPassword" className="block text-white font-semibold mb-2">Re-enter New Password <span class="text-red-500">*</span> </label>
                                <input
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    type="password"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="w-full bg-red-600 text-white p-3 rounded-md font-semibold hover:bg-red-700 transition">
                                Update Password
                            </button>
                            <p style={{ fontSize: '0.9rem', marginTop: '1rem' }}>
                                Forgot your current password? Please email us at <a className="text-indigo-200 hover:underline" href="mailto:aiampdse@agivant.com">aiampdse@agivant.com</a>
                            </p>

                        </form>

                        {errorMessage && <p className="text-[#FFAA00] ">{errorMessage}</p>}
                        {successMessage && <p className="text-green-400 font-semibold ">{successMessage}</p>}
                    </div>
                </div>
                {/* Right Side (can remain empty or have background) */}
                <div className="hidden md:block"></div>
            </div>

            <Footer />
        </div>
    );
};

export default ResetPassword;
